import { Injectable, inject } from '@angular/core';
import {
  ErrorUIToastMessageCategory,
  InfoUIToastMessageCategory,
  PinnaklUIToastMessageAPI,
  SuccessUIToastMessageCategory,
  WarningUIToastMessageCategory,
} from '@pinnakl/shared/types';
import { SessionExpirationService } from '@pinnakl/shared/util-providers';
import { MessageService, ToastMessageOptions } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class UiToastMessageService implements PinnaklUIToastMessageAPI {
  private readonly messageService = inject(MessageService);
  private readonly sessionExpiration = inject(SessionExpirationService);

  add = this.messageService.add.bind(this.messageService);
  addAll = this.messageService.addAll.bind(this.messageService);
  clear = this.messageService.clear.bind(this.messageService);
  messageObserver = this.messageService.messageObserver;
  clearObserver = this.messageService.clearObserver;

  error(
    msg: string,
    category: ErrorUIToastMessageCategory = ErrorUIToastMessageCategory.Error,
    options?: ToastMessageOptions,
  ): void {
    if (this.sessionExpiration.expired()) {
      return;
    }
    this.messageService.add({
      severity: 'error',
      summary: category,
      detail: msg,
      life: 10000,
      ...options,
    });
  }

  info(
    msg: string,
    category: InfoUIToastMessageCategory = InfoUIToastMessageCategory.Info,
    options?: ToastMessageOptions,
  ): void {
    this.messageService.add({
      severity: 'info',
      summary: category,
      detail: msg,
      life: 10000,
      ...options,
    });
  }

  success(
    msg: string,
    category: SuccessUIToastMessageCategory = SuccessUIToastMessageCategory.Success,
    options?: ToastMessageOptions,
  ): void {
    this.messageService.add({
      severity: 'success',
      summary: category,
      detail: msg,
      life: 5000,
      ...options,
    });
  }

  warning(
    msg: string,
    category: WarningUIToastMessageCategory = WarningUIToastMessageCategory.Warning,
    options?: ToastMessageOptions,
  ): void {
    this.messageService.add({
      severity: 'warn',
      summary: category,
      detail: msg,
      life: 10000,
      ...options,
    });
  }
}
